import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { ContactRequestDto } from '@app/data/dtos/contact/contact.dto';
import { TourKeys } from '@app/entities/enums/tour.enum';
import { NewsItem } from '@app/entities/interfaces/news/news.interface';
import { Message } from '@app/entities/models/message/message.model';
import { UserLogin, UserLoginPhone } from '@app/entities/models/user/login.model';
import { UserOnBoarding } from '@app/entities/models/user/on-boarding.model';
import { RepresentedUser } from '@app/entities/models/user/represented-user.model';
import { User } from '@app/entities/models/user/user.model';

export interface UserRepository {
  requestUserInfo(): Promise<User>;
  syncImage(): Promise<User>;
  getRepresentedUsers(): Observable<RepresentedUser[]>;
  getContactMessages(): Observable<Message[]>;
  setAcceptConditions(email: string, acceptation: boolean): Observable<object>;
  editAvatar(newAvatar: File): Observable<object>;
  deleteAvatar(): Observable<object>;
  setLanguage(anguage_code: string, language_country: string): Promise<User>;
  postContact(data: ContactRequestDto): Observable<object>;
  setAcceptNews(newsItem: NewsItem): Observable<object>;
  setWalkthroughSeen(walkthroughKey: TourKeys): Observable<object>;
  getOnBoarding(): Observable<UserOnBoarding>;
  updateOnBoarding(): Observable<object>;
  getUserLogin(userId: string): Observable<UserLogin>;
  checkUserLoginPhone(userId: string, phone: string): Observable<UserLoginPhone>;
}

export const USER_REPOSITORY = new InjectionToken<UserRepository>('USER_REPOSITORY');
